import React from 'react';
import { loginPageStyles } from '../../../../styles';
import { Box } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'material-react-toastify';
import { Toast as CustomToast, QrScanner } from '../../../../Components';
import { validateQr } from '../../../../redux/features/Practice';
import PropTypes from 'prop-types';

const LogisticsQrCodeScan = ({ enroutedPractice, setStep }) => {
  const classes = loginPageStyles();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.userReducer.user);

  const validateQRCode = (scanResult) => {
    try {
      // payload for validating QR
      const payload = {
        rider_practice_check_ins: {
          rider_id: user.id,
          practice_id: enroutedPractice.id,
          clinic_code: JSON.parse(scanResult.data),
        },
      };

      // Calling Validate QR API
      dispatch(validateQr(payload))
        .unwrap()
        .then(() => {
          toast(<CustomToast severity="success" message="QR code Verified" />, {
            closeButton: false,
          });
          setStep((prev) => prev + 1);
        })
        .catch(() => toasifyInValidQRError());
    } catch (error) {
      toasifyInValidQRError();
    }
  };

  // This jsx component is for rendering invalid qr toast
  const toasifyInValidQRError = () => {
    toast(
      <CustomToast
        severity="warning"
        message="QR code does not match. Please check current location"
      />,
      { closeButton: false }
    );
  };
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box
        className={classes.heading10}
        sx={{
          textAlign: 'center',
          fontWeight: '700',
          fontSize: '21px',
          lineHeight: '27px',
          color: '#054E8B',
          fontFamily: 'Mukta',
          my: '10px',
        }}
      >
        Scan Clinic QR Code
      </Box>
      <QrScanner validateQRCode={validateQRCode} />
      <Box
        className={classes.heading}
        sx={{
          fontSize: '15px',
          textAlign: 'center',
          mx: 'auto',
          width: '100%',
          marginTop: '10px',
          color: '#2A3752',
          lineHeight: '19px',
        }}
      >
        Scan the Clinic QR Code to check into the clinic
      </Box>
    </Box>
  );
};
LogisticsQrCodeScan.propTypes = {
  enroutedPractice: PropTypes.object.isRequired,
  setStep: PropTypes.func.isRequired,
};
export default LogisticsQrCodeScan;
